import React from "react";

export default function LoadingFamilySkeleton({ label = "Loading your family..." }) {
  return (
    <div className="App" style={{ display: "grid", placeItems: "center", minHeight: "100vh", padding: 20 }}>
      <div className="glass parent-card loading-skeleton-card" style={{ width: "min(520px, 100%)" }}>
        <h2>{label}</h2>
        <div className="skeleton-line" />
        <div className="skeleton-line short" />
        <div className="skeleton-grid">
          <div className="skeleton-block" />
          <div className="skeleton-block" />
          <div className="skeleton-block" />
        </div>
      </div>
    </div>
  );
}
